export const createTranslationKey = (key: string, countryCode: string) =>
  `${key}_${countryCode}`;

const createTranslationKeyWithType =
  (type: string) => (key: string, countryCode: string) =>
    `${key}_${type}_${countryCode}`;

export const getActionTitleTranslationKey =
  createTranslationKeyWithType("actionTitle");
export const getActionHelpTranslationKey =
  createTranslationKeyWithType("actionHelp");
export const getActionDescriptionTranslationKey =
  createTranslationKeyWithType("actionDescription");
